import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import FullPageLoader from '../components/FullPageLoader';
import useAuth from '../hooks/useAuth';
import { buildLoginRedirectPath } from './authRedirect';

const PrivateRoute: React.FC = () => {
  const location = useLocation();
  const { status } = useAuth();

  if (status === 'loading') {
    return <FullPageLoader message="Carregando sua sessao..." />;
  }

  if (status === 'anonymous') {
    return (
      <Navigate
        to={buildLoginRedirectPath(location.pathname, location.search, location.hash)}
        replace
      />
    );
  }

  return <Outlet />;
};

export default PrivateRoute;
